import { render, staticRenderFns } from "./HousePayDesktop.vue?vue&type=template&id=0b0c642d&scoped=true&"
import script from "./HousePayDesktop.vue?vue&type=script&lang=js&"
export * from "./HousePayDesktop.vue?vue&type=script&lang=js&"
import style0 from "./HousePayDesktop.vue?vue&type=style&index=0&id=0b0c642d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0c642d",
  null
  
)

export default component.exports